import { Component, OnInit } from '@angular/core';
import { Input,ViewChild, TemplateRef } from '@angular/core';
import { Gallery, GalleryItem, ThumbnailsPosition, ImageSize,GalleryModule, ImageItem  } from 'ng-gallery';//from "@ngx-gallery/core";
//import { Lightbox } from "@ngx-gallery/lightbox";
import { Lightbox } from 'ng-gallery/lightbox';
import { LightboxModule } from 'ng-gallery/lightbox';
import { AveriasService } from '../servicios/averias.service';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { NbDialogRef } from '@nebular/theme';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { GalleryState } from 'ng-gallery';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-edit-inspeccion-averia',
    templateUrl: './edit-inspeccion-averia.component.html',
    styleUrls: ['./edit-inspeccion-averia.component.css'],
    standalone: true,
    imports: [SpinnerComponent, FormsModule,CommonModule,NbCardModule,
      NbIconModule,DropdownModule,GalleryModule,  
      GalleryModule,
    LightboxModule 
  ],
})
export class EditInspeccionAveriaComponent implements OnInit {
  @Input() public detalle: any;
  @Input() public tipoReporte: any;
  @ViewChild('itemTemplate') itemTemplate: TemplateRef<any>;
  @Input() public actualizar: boolean = false;

  galleryState: Observable<GalleryState>;

  durationInSeconds = 3;
  items: GalleryItem[];
  indexFoto = 0;
  idFoto = 0;
  imageData = fotosDefault;
  showSpinnerFotos: boolean = true;
  

  idCliente;
  infoPopup;

  editar = false;
  habilitarGuardarCambios = false;
  deshabilitarSolucionar = false;

  SeveridadSeleccionada;
  tipoAveriaSeleccionada;
  areaComponenteSeleccionada;
  responsablesSeleccionada;
  zonaCuadranteDetalleSeleccionada;
  clasificacionSeleccionada;
  severidad = [];
  tipoAveria = [];
  areaComponente = [];
  responsables = [];
  zonaCuadranteDetalle = [];
  clasificacion = [];
  tipoResponsable: boolean = false;
  severidadesLoaded = false;
  tipoAveriasLoaded = false;
  responsablesLoaded = false;
  zonaCuadDetallesLoaded = false;
  clasificacionLoaded = false;
  showSpinnerGuardar:boolean = false;
  myConfig = {
    btnContainerClass: '',            // The CSS class(es) to be applied to the button container
    btnClass: 'default',              // The CSS class(es) that will be applied to the buttons e.g. default is needed for FontAwesome icons, while not needed for Material Icons
    btnSubClass: 'material-icons',    // The CSS class(es) that will be applied to span elements inside material buttons (a Elements)
    zoomFactor: 0.1,                  // The amount that the scale will be increased by
    containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
    wheelZoom: true,                  // If true, the mouse wheel can be used to zoom in
    allowFullscreen: false,            // If true, the fullscreen button will be shown, allowing the user to enter fullscreen mode
    allowKeyboardNavigation: true,    // If true, the left / right arrow keys can be used for navigation
    btnShow: {                        // Control which icons should be visible                
      zoomIn: false,
      zoomOut: false,
      rotateClockwise: false,
      rotateCounterClockwise: false,
      next: false,
      prev: false,
      reset: false
    },
    btnIcons: {                       // The icon classes that will apply to the buttons. By default, font-awesome is used.
      zoomIn: {
        classes: 'fa fa-plus',        // this property will be used for FontAwesome and other libraries to set the icons via the classes - choose one: classes or text
        text: 'zoom_in'               // this property will be used for Material-Icons and similar libraries to set the icons via the text
      },
      zoomOut: {
        classes: 'fa fa-minus',
        text: 'zoom_out'
      },
      rotateClockwise:  {
        classes: 'fa fa-repeat',
        text: 'rotate_right'
      },
      rotateCounterClockwise:  {
        classes: 'fa fa-undo',
        text: 'rotate_left'
      },
      next:  {
        classes: 'fa fa-arrow-right',
        text: 'arrow_right'
      },
      prev:  {
        classes: 'fa fa-arrow-left',
        text: 'arrow_left'
      },
      fullscreen:  {
        classes: 'fa fa-arrows-alt',
        text: 'fullscreen'
      },
      reset:  {
        classes: 'fa fa-undo',
        text: 'restore'
      }
    }
  };

   selectedImage : string = '';

  constructor(public lightbox: Lightbox, private servicioAverias:AveriasService,
    public gallery: Gallery, private _snackBar: MatSnackBar, 
    public usersRol:PerfilesUsuarioService, public dialogRef: NbDialogRef<EditInspeccionAveriaComponent>) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));    
    this.consultarDetalle(); 
  }

  consultarDetalle(){
    let idAveria = { idVinInspeccionAveria: this.detalle};
    let reporte = this.tipoReporte;
    this.showSpinnerFotos = true;
    //esto es para mostrar el tipo de responsable y ocultar el responsable caudno el reporte es 11 o 12
    if (reporte == 11 ||  reporte == 12) 
    {
      this.tipoResponsable = true;
    }
    else {
      this.tipoResponsable = false
    }

    this.servicioAverias.getDetalleInspeccionAveria(idAveria).subscribe( data => {
      this.infoPopup = data;
      this.imageData = this.infoPopup.listaFotosAveria.length > 0 ? this.infoPopup.listaFotosAveria : 2;
      this.mapeoFotos();
      this.showSpinnerFotos = false;   
    });
  }

  mapeoFotos(){
    if (this.infoPopup.listaFotosAveria.length>0){
      this.imageData= [];
      this.infoPopup.listaFotosAveria.forEach(element => {
        this.imageData.push({
          id: element.id,
          src: 'data:image/png;base64,'+ element.foto,
          thumb: 'data:image/png;base64,' +  element.foto
        })
      });
    }

    this.selectedImage = this.imageData[0].src;

   // this.items = this.imageData.map(img => new ImageItem({ src: img.src, thumb: img.thumb }));

    //    const images = [
    //   { src: 'data:image/png;base64,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', 
    //   thumb: 'data:image/png;base64,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' },
    //   { src: 'https://picsum.photos/id/1012/600/400', thumb: 'https://picsum.photos/id/1012/100/67' },
    //   { src: 'https://picsum.photos/id/1013/600/400', thumb: 'https://picsum.photos/id/1013/100/67' }
    // ];
    //const items2
    this.items = this.imageData.map(img => new ImageItem({ src: img.src, thumb: img.thumb }));

    /*
    // Creat gallery items  
    this.items = this.imageData.map(item => {
      return {
        type: "imageViewer",
        data: {
          src:  item.src,
          thumb:  item.thumb
        }
      };
    });
*/

     // Get a lightbox gallery ref
     const lightboxRef = this.gallery.ref("lightbox");
    this.galleryState = lightboxRef.state;
     /*
     // Add custom gallery config to the lightbox (optional)
     lightboxRef.setConfig({
       imageSize: ImageSize.Cover,
       thumbPosition: ThumbnailsPosition.Top,
       itemTemplate: this.itemTemplate,
       //gestures: false
     });
*/

    // lightboxRef.setConfig({
    //   thumbPosition: 'bottom', // Thumbnails abajo
    //   imageSize: 'cover'       // Imagen ajustada
    // });
 
     // Load items into the lightbox gallery ref
     lightboxRef.load(this.items);    

  }



  
//GALLERYA MANUAL ****************************************************

//  selectedImage = this.imageData[0].src;

    selectedIndex = 0;
    get selectedImageData() {
      return this.imageData[this.selectedIndex].src;
    }

    lightboxOpen = false;
    zoom = 1;
    readonly zoomStep = 0.1;
    readonly zoomMin = 1;
    readonly zoomMax = 3;

    // Arrastre
    isDragging = false;
    startX = 0;
    startY = 0;
    currentX = 0;
    currentY = 0;

    selectImageByIndex(index: number) {
      this.selectedIndex = index;
      this.resetZoomAndPosition();
    }

    selectImage(src: string) {
      const index = this.imageData.findIndex(i => i.src === src);
      if (index !== -1) this.selectImageByIndex(index);
    }

    openLightbox() {
      this.lightboxOpen = true;
      this.resetZoomAndPosition();
    }

    closeLightbox() {
      this.lightboxOpen = false;
      this.resetZoomAndPosition();
    }

    resetZoomAndPosition() {
      this.zoom = 1;
      this.currentX = 0;
      this.currentY = 0;
    }

    onWheel(event: WheelEvent) {
      event.preventDefault();

      if (event.deltaY < 0) {
        this.zoom = Math.min(this.zoom + this.zoomStep, this.zoomMax);
      } else {
        this.zoom = Math.max(this.zoom - this.zoomStep, this.zoomMin);
      }

      if (this.zoom <= 1) {
        this.currentX = 0;
        this.currentY = 0;
      }
    }

    onMouseDown(event: MouseEvent) {
      if (this.zoom <= 1) return;
      this.isDragging = true;
      this.startX = event.clientX - this.currentX;
      this.startY = event.clientY - this.currentY;
    }

    onMouseMove(event: MouseEvent) {
      if (!this.isDragging) return;
      this.currentX = event.clientX - this.startX;
      this.currentY = event.clientY - this.startY;
      // Limitar movimiento si quieres aquí
    }

    onMouseUp() {
      this.isDragging = false;
    }

    onMouseLeave() {
      this.isDragging = false;
    }

    // Navegación
    prevImage() {
      if (this.selectedIndex > 0) {
        this.selectImageByIndex(this.selectedIndex - 1);
      }
    }

    nextImage() {
      if (this.selectedIndex < this.imageData.length -1) {
        this.selectImageByIndex(this.selectedIndex + 1);
      }
    }


  // END GALLERYA MANUAL ****************************************************



  insertarTipo(armarTipo){
    armarTipo.content.forEach(element => {
      this.tipoAveria.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.tipoAveriaSeleccionada = this.infoPopup.idTipoAveria;
    this.tipoAveriasLoaded = true;
  };

  //Severidad
  insertarSeveridad(armarSeveridad){
    armarSeveridad.content.forEach(element => {
      this.severidad.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.SeveridadSeleccionada = this.infoPopup.idSeveridad;
    this.severidadesLoaded = true;
  };

  insertarZonaCuadranteDetalle(armarZonaCuadranteDetalle){
    armarZonaCuadranteDetalle.forEach(element => {
      this.zonaCuadranteDetalle.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.zonaCuadranteDetalleSeleccionada = this.infoPopup.idZonaCuadranteDetalle;
    this.zonaCuadDetallesLoaded = true;
  };

  insertarResponsables(armarResponsables){
    armarResponsables.forEach(element => {
      this.responsables.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    this.responsablesSeleccionada = this.infoPopup.idResponsable;
    this.responsablesLoaded = true;
  }; 
  insertarClasificacion(armarClasificacion) {
    armarClasificacion.content.forEach(element => {
      this.clasificacion.push({
        label: element.descripcion,
        value: element.id
      });
    })
    this.clasificacionSeleccionada = this.infoPopup.idClasificacion;
    this.clasificacionLoaded = true;
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  closeDialog(){
    this.dialogRef.close()
  }
}

var fotosDefault = [
  {
    id: 0,
    src: "assets/img/no_disponible.jpg",
    thumb: "assets/img/no_disponible.jpg"
  }
];
